<template>
    <div class="form-client">

        <mu-form :model="form">

            <div class="steps">

                <!-- Step 1 -->
                <div id="step-1" class="step step-1" :class="{active: activeStep == 1}">
                    <div class="number">1</div>
                    <div class="title">Dados do cliente</div>
                    <mu-paper class="content" :z-depth="1">

                        <!-- Tipo Pessoa -->
                        <mu-form-item prop="radio">
                            <mu-radio v-model="form.person_type" value="PJ" label="Pessoa Jurídica"></mu-radio>
                            <mu-radio v-model="form.person_type" value="PF" label="Pessoa Física"></mu-radio>
                        </mu-form-item>

                        <!-- Tipo Cliente -->
                        <mu-select label="Tipo Cliente" v-model="form.custom_type" full-width v-if="isZiad()">
                            <mu-option v-for="(option, key) in options.custom_type" :key="key" :label="option.label" :value="option.value"></mu-option>
                        </mu-select>

                        <!-- Razão Social -->
                        <mu-text-field v-model="form.social_name" full-width :label="labelSocialname"></mu-text-field>

                        <mu-row gutter>
                            <mu-col span="12" sm="12" md="6" lg="6" xl="6">
                                <!-- Nome Fantasia -->
                                <mu-text-field v-model="form.nick_name" full-width :label="labelNickname"></mu-text-field>
                            </mu-col>
                            <mu-col span="12" sm="12" md="6" lg="6" xl="6">
                                <!-- CNPJ/CPF -->
                                <mu-text-field v-model="form.document_id" v-mask="maskDocument" full-width :label="labelDocument"></mu-text-field>
                            </mu-col>
                        </mu-row>

                        <mu-row gutter v-if="form.person_type == 'PJ'">
                            <mu-col span="12" sm="12" md="6" lg="6" xl="6">
                                <!-- Inscrição Estadual -->
                                <mu-text-field v-model="form.reg_state" full-width label="Inscrição Estadual"></mu-text-field>
                            </mu-col>
                            <mu-col span="12" sm="12" md="6" lg="6" xl="6">
                                <!-- Inscrição Municipal -->
                                <mu-text-field v-model="form.reg_town" full-width label="Inscrição Municipal"></mu-text-field>
                            </mu-col>
                        </mu-row>

                        <mu-row gutter>
                            <mu-col span="12" sm="12" md="6" lg="6" xl="6">
                                <!-- Telefone Fixo -->
                                <mu-text-field v-model="form.phone_number" full-width v-mask="['(##) ####-####', '(##) #####-####']" label="Telefone (Fixo)"></mu-text-field>
                            </mu-col>
                            <mu-col span="12" sm="12" md="6" lg="6" xl="6">
                                <!-- Telefone Celular -->
                                <mu-text-field v-model="form.mobile_number" v-mask="['(##) ####-####', '(##) #####-####']" full-width label="Telefone (Celular) *"></mu-text-field>
                            </mu-col>
                        </mu-row>

                        <!-- E-mail -->
                        <mu-text-field v-model="form.email" type="email" full-width label="E-mail *"></mu-text-field>

                        <!-- Status -->
                        <mu-select label="Status" v-model="form.status" full-width>
                            <mu-option v-for="(option, key) in options.status" :key="key" :label="option.label" :value="option.value"></mu-option>
                        </mu-select>

                        <!-- Cada usuário só poderá visualizar suas campanhas. -->
                        <mu-form-item>
                            <mu-checkbox label="Cada usuário só poderá visualizar suas campanhas." v-model="form.showuserreg"></mu-checkbox>
                        </mu-form-item>

                        <!-- Ignorar limpeza preditiva? -->
                        <mu-form-item>
                            <mu-checkbox label="Ignorar limpeza preditiva?" v-model="form.ignore_predictive"></mu-checkbox>
                        </mu-form-item>

                    </mu-paper>
                    <mu-paper class="buttons" :z-depth="1">
                        <mu-flex justify-content="center" align-items="center">
                            <mu-button round @click="handleNext" color="primary" :disabled="!form.nick_name || !form.social_name || !form.document_id || !form.mobile_number || !form.email">
                                Próximo
                                <font-awesome-icon icon="chevron-right" class="icon-md icon-margin-right"/>
                            </mu-button>
                        </mu-flex>
                    </mu-paper>
                </div>

                <!-- Step 2 -->
                <div id="step-2" class="step step-2" :class="{active: activeStep == 2}">
                    <div class="line"></div>
                    <div class="number">2</div>
                    <div class="title">Logotipo do cliente</div>
                    <mu-paper class="content" :z-depth="1">
                        <!-- Upload de arquivo -->
                        <div class="upload" v-if="!form.logo_url">
                            <input type="file" @change="handleFileUpload">
                            <font-awesome-icon icon="upload" size="2x" />
                            <h3 class="title">Selecione o logotipo da empresa</h3>
                            <p>Formatos permitidos: JPG, PNG ou GIF</p>
                        </div>
                        <div class="upload-image" v-else>
                            <mu-row align-items="center">
                                <mu-col span="12" sm="12" md="8" lg="8" xl="8">
                                    <img :src="getImage()" />
                                </mu-col>
                                <mu-col span="12" sm="12" md="4" lg="4" xl="4">
                                    <div class="button">
                                        <mu-button round @click="removeImage" color="red">
                                            Remover Logotipo
                                        </mu-button>
                                    </div>
                                </mu-col>
                            </mu-row>
                        </div>
                    </mu-paper>
                    <mu-paper class="buttons" :z-depth="1">
                        <mu-flex justify-content="center" align-items="center">
                            <mu-button color="#EEF1F3" textColor="#666" round @click="handlePrev">
                                <font-awesome-icon icon="chevron-left" class="icon-md icon-margin-left"/>
                                Voltar
                            </mu-button>
                            <mu-button round @click="handleNext" color="primary">
                                Próximo
                                <font-awesome-icon icon="chevron-right" class="icon-md icon-margin-right"/>
                            </mu-button>
                        </mu-flex>
                    </mu-paper>
                </div>

                <!-- Step 3 -->
                <div id="step-3" class="step step-3" :class="{active: activeStep == 3}">
                    <div class="line"></div>
                    <div class="number">3</div>
                    <div class="title">Assinatura e dados do plano</div>
                    <mu-paper class="content" :z-depth="1">

                        <!-- Limitar mensagem a 160 caracteres -->
                        <mu-form-item prop="checkbox">
                            <mu-checkbox v-model="form.limit_characteres" label="Limitar mensagem a 160 caracteres"></mu-checkbox>
                        </mu-form-item>

                        <!-- Tipo Assinatura -->
                        <mu-select label="Tipo Assinatura" v-model="form.signature_type" full-width @change="changeSignatureType()">
                            <mu-option v-for="(option, key) in options.signature_type" :key="key" :label="option.label" :value="option.value"></mu-option>
                        </mu-select>

                        <!-- Créditos mensais -->
                        <!-- <div>
                            <label>Créditos mensais</label>
                            <v-money v-model="form.tax" v-bind="moneyFormatCredit" :disabled="form.signature_type == 'T'"></v-money><br>
                            <small>* Quantidade de créditos disponibilizados a cada mês para a conta</small>
                        </div> -->

                        <!-- <mu-checkbox v-if="!company.isProvider && form.signature_type != 'T'" v-model="form.autocredit" label="Gerar crédito automático?"></mu-checkbox><br> -->

                        <br><br>

                        <div class="header">
                            <mu-row justify-content="center" align-items="center">
                                <mu-col span="12" sm="12" md="6" lg="6" xl="6">
                                    Configurações dos serviços
                                </mu-col>
                                <mu-col span="12" sm="12" md="6" lg="6" xl="6" class="button">
                                    <mu-button round textColor="primary" @click="handleDialogService(true)" v-if="form_services.length > 0">
                                        <font-awesome-icon icon="plus-circle" class="icon-md icon-margin-left"/>
                                        Adicionar
                                    </mu-button>
                                </mu-col>
                            </mu-row>
                        </div>

                        <table class="mu-table">
                            <thead v-if="form_services.length > 0">
                                <tr>
                                    <th>Tipo</th>
                                    <th>Canal</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody v-if="form_services.length > 0">
                                <tr v-for="(item, key) in form_services" :key="key">
                                    <td>{{ getServiceName(item.id_services) }}</td>
                                    <td>
                                        <span v-if="isZiad()">{{ getChannelName(item.ch1) }} / </span>{{ priceFormat(item.ch1_tax, 4) }}
                                    </td>
                                    <td class="text-center">
                                        <font-awesome-icon icon="times" class=" delete icon-sm icon-margin-left color-red" @click="deleteService(item)"/>
                                    </td>
                                </tr>
                            </tbody>
                            <tfoot v-if="form_services.length == 0">
                                <tr>
                                    <td colspan="3">
                                        <div class="empty">
                                            <p>Adicione os serviços que o cliente contratou</p>
                                            <mu-button round color="secondary" @click="handleDialogService(true)">
                                                <font-awesome-icon icon="plus-circle" class="icon-md icon-margin-left"/>
                                                Adicionar
                                            </mu-button>
                                        </div>
                                    </td>
                                </tr>
                            </tfoot>
                        </table>

                        <!-- Dialogo para confirmar exclusão de campanha -->
                        <mu-dialog title="Adicionar serviço" width="600" max-width="80%" scrollable :esc-press-close="false" :overlay-close="false" :open.sync="service.openService">
                            <div>

                                <!-- Tipo do serviço -->
                                <mu-select label="Tipo Serviço" v-model="service.id_services" full-width @change="setChannel()">
                                    <mu-option v-for="(option, key) in options.services" :key="key" :label="option.name" :value="option.id"></mu-option>
                                </mu-select>

                                <!-- Canais / Tarifas -->
                                <mu-row gutter v-if="company.customType == 'R' && company.isProvider">
                                    <mu-col span="12" sm="12" md="6" lg="6" xl="6">
                                        <mu-select label="Canal" v-model="service.ch1" full-width>
                                            <mu-option v-for="(option, key) in filteredChannels" :key="key" :label="option.code" :value="option.code"></mu-option>
                                        </mu-select>
                                    </mu-col>
                                    <mu-col span="12" sm="12" md="6" lg="6" xl="6">
                                        <label class="label-money">Tarifa</label>
                                        <v-money v-model="service.ch1_tax" v-bind="moneyFormat"></v-money><br>
                                        <small>{{ getMinMaxChannel(service.ch1) }}</small>
                                    </mu-col>
                                </mu-row>
                                <mu-row gutter v-else>
                                    <mu-col span="12" sm="12" md="12" lg="12" xl="12">
                                        <label class="label-money">Tarifa</label>
                                        <v-money v-model="service.ch1_tax" v-bind="moneyFormat"></v-money><br>
                                        <small>{{ getMinMaxChannel(service.ch1) }}</small>
                                    </mu-col>
                                </mu-row>

                                <br>

                                <mu-flex>
                                    <mu-button slot="actions-" round color="primary" @click="addService()" :disabled="validateService()">
                                        <font-awesome-icon icon="check" class="icon-md icon-margin-left"/>
                                        Adicionar
                                    </mu-button>
                                    <mu-button slot="actions-" round @click="handleDialogService(false)">Cancelar</mu-button>
                                </mu-flex>

                            </div>
                        </mu-dialog>

                    </mu-paper>
                    <mu-paper class="buttons" :z-depth="1">
                        <mu-flex justify-content="center" align-items="center">
                            <mu-button color="#EEF1F3" textColor="#666" round @click="handlePrev">
                                <font-awesome-icon icon="chevron-left" class="icon-md icon-margin-left"/>
                                Voltar
                            </mu-button>
                            <mu-button round @click="handleNext" color="primary" v-if="type == 'create'" :disabled="!form.signature_type || form_services.length == 0">
                                Próximo
                                <font-awesome-icon icon="chevron-right" class="icon-md icon-margin-right"/>
                            </mu-button>
                            <mu-button round @click="saveForm()" color="primary" v-if="type == 'edit'" :disabled="!form.signature_type || form_services.length == 0">
                                 <font-awesome-icon icon="check" class="icon-md icon-margin-left"/>
                                Salvar
                            </mu-button>
                        </mu-flex>
                    </mu-paper>
                </div>

                <!-- Step 4 -->
                <div id="step-4" class="step step-4" :class="{active: activeStep == 4}" v-if="type == 'create'">
                    <div class="line"></div>
                    <div class="number">4</div>
                    <div class="title">Dados do usuário administrador</div>
                    <mu-paper class="content" :z-depth="1">
                        <mu-row gutter>
                            <mu-col span="12" sm="12" md="6" lg="6" xl="6">
                                <!-- Nome -->
                                <mu-text-field v-model.trim="form.user_name" full-width label="Nome"></mu-text-field>
                            </mu-col>
                            <mu-col span="12" sm="12" md="6" lg="6" xl="6">
                                <!-- E-mail -->
                                <mu-text-field v-model.trim="form.user_email" type="email" full-width label="E-mail"></mu-text-field>
                            </mu-col>
                            <mu-col span="12" sm="12" md="6" lg="6" xl="6">
                                <!-- Login -->
                                <mu-text-field v-model.trim="form.user_login" full-width label="Login"></mu-text-field>
                            </mu-col>
                            <mu-col span="12" sm="12" md="6" lg="6" xl="6">
                                <!-- Senha -->
                                <mu-text-field v-model.trim="form.user_password" help-text="" @focus="verifyFocus()" @blur="verifyFocus()" type="password" full-width label="Senha"></mu-text-field>
                                <small class="info-form" v-if="passFocus">A senha deve ter pelo menos 6 caracteres e ser composta por letras maiúsculas, minúsculas e números!</small>
                            </mu-col>
                        </mu-row>
                    </mu-paper>
                    <mu-paper class="buttons" :z-depth="1">
                        <mu-flex justify-content="center" align-items="center">
                            <mu-button color="#EEF1F3" textColor="#666" round @click="handlePrev">
                                <font-awesome-icon icon="chevron-left" class="icon-md icon-margin-left"/>
                                Voltar
                            </mu-button>
                            <mu-button round @click="saveForm()" color="primary" :disabled="!form.user_name || !form.user_email || !form.user_email || !form.user_password">
                                <font-awesome-icon icon="check" class="icon-md icon-margin-left"/>
                                Salvar
                            </mu-button>
                        </mu-flex>
                    </mu-paper>
                </div>

                <!-- Step 5 / Finished -->
                <div id="step-5" class="step step-finished" v-if="finished">
                    <img src="/svg/settings/client-success.svg" width="300px" />
                    <p>Parabéns, o cliente foi salvo com sucesso!</p>
                    <mu-button round color="#999" :to="{ name: 'app.settings.clients' }">
                         <font-awesome-icon icon="eye" class="icon-md icon-margin-left"/>
                        Ver Clientes
                    </mu-button>
                </div>

            </div>

        </mu-form>

        <!-- Bloco para excluir o contato -->
        <mu-paper class="cancel" :z-depth="1" v-if="type == 'edit' && !finished">

            <!-- Pergunta para excluir o contato  -->
            <mu-row justify-content="center" align-items="center">
                <mu-col span="12" sm="12" md="8" lg="8" xl="8">
                    <mu-flex class="title" justify-content="start" align-items="center">
                        <font-awesome-icon icon="exclamation-triangle" class="icon-md icon-margin-left color-red"/>
                        <strong>Excluir cliente</strong>
                    </mu-flex>
                    Todos os dados deste cliente serão perdidos e não terá como voltar.
                </mu-col>
                <mu-col span="12" sm="12" md="4" lg="4" xl="4">
                    <div class="text-right">
                        <mu-button round color="error" @click="handleDialogDelete(true)">
                            <font-awesome-icon icon="trash" class="icon-md icon-margin-left"/>
                            Excluir
                        </mu-button>
                    </div>
                </mu-col>
            </mu-row>

            <!-- Dialogo para confirmar exclusão de campanha -->
            <mu-dialog title="Excluir o cliente" width="600" max-width="80%" :esc-press-close="false" :overlay-close="false" :open.sync="cancel.openDelete">
                <p>Tem certeza que deseja excluir o cliente <strong>{{ form.nick_name }}</strong></p>
                <mu-button slot="actions" round @click="handleDialogDelete(false)">Cancelar</mu-button>
                <mu-button slot="actions" round color="error" @click="deleteForm">
                    <font-awesome-icon icon="check" class="icon-md icon-margin-left"/>
                    Confirmar
                </mu-button>
            </mu-dialog>

        </mu-paper>

    </div>
</template>

<script>
    import { mask } from 'vue-the-mask'
    import { Money } from 'v-money'
    import ClientsServices from '@/services/settings/clients'
    import ChannelsServices from '@/services/settings/channels'
    import ChannelsClientsServices from '@/services/settings/channels-clients'
    import ServicesServices from '@/services/settings/services'

    export default {
        name: 'mu-form-client',
        props: ['type'],

        // ╔╦╗╦╦═╗╔═╗╔═╗╔╦╗╦╦  ╦╔═╗╔═╗
        //  ║║║╠╦╝║╣ ║   ║ ║╚╗╔╝║╣ ╚═╗
        // ═╩╝╩╩╚═╚═╝╚═╝ ╩ ╩ ╚╝ ╚═╝╚═╝
        directives: {
            mask
        },

        // ╔═╗╔═╗╔╦╗╔═╗╔═╗╔╗╔╔═╗╔╗╔╔╦╗╔═╗
        // ║  ║ ║║║║╠═╝║ ║║║║║╣ ║║║ ║ ╚═╗
        // ╚═╝╚═╝╩ ╩╩  ╚═╝╝╚╝╚═╝╝╚╝ ╩ ╚═╝
        components: {
            'v-money': Money
        },

        // ╔╦╗╔═╗╔╦╗╔═╗
        //  ║║╠═╣ ║ ╠═╣
        // ═╩╝╩ ╩ ╩ ╩ ╩
        data () {
            return {
                activeStep: 1,
                options: {
                    custom_type: [
                        { label: 'Revenda', value: 'R' },
                        { label: 'Cliente', value: 'C' }
                    ],
                    signature_type: [
                        { label: 'Pós Pago', value: 'C' },
                        { label: 'Pré Pago', value: 'P' },
                        { label: 'Teste', value: 'T' }
                    ],
                    status: [
                        { label: 'Inativo', value: 'I' },
                        { label: 'Ativo', value: 'A' }
                    ],
                    services: [],
                    channels: []
                },
                moneyFormat: {
                    decimal: ',',
                    thousands: '.',
                    prefix: 'R$ ',
                    precision: 4
                },
                moneyFormatCredit: {
                    decimal: ',',
                    thousands: '.',
                    prefix: 'R$ ',
                    precision: 2
                },
                form: {
                    status: 'A',
                    person_type: 'PJ',
                    autocredit: false,
                    limit_characteres: true,
                    tax: 0,
                    logo_url: '',
                    showuserreg: false,
                    ignore_predictive: false
                },
                imageUpload: false,
                cancel: {
                    openDelete: false,
                    loading: false
                },
                form_services: [],
                service: {
                    openService: false,
                    id_services: null,
                    ch1: null,
                    ch1_tax: 0
                },
                file: null,
                passFocus: false
            }
        },

        // ╔═╗╔═╗╔╦╗╔═╗╦ ╦╔╦╗╔═╗╔╦╗
        // ║  ║ ║║║║╠═╝║ ║ ║ ║╣  ║║
        // ╚═╝╚═╝╩ ╩╩  ╚═╝ ╩ ╚═╝═╩╝

        computed: {

            /**
             * Formata que tipo de mascara irá usar de acordo com o person_type da empresa
             */
            maskDocument () {
                return this.form.person_type === 'PJ' ? '##.###.###/####-##' : '###.###.###-##'
            },

            /**
             * Mostra que label mostrar de acordo com o person_type da empresa
             */
            labelSocialname () {
                return (this.form.person_type === 'PJ' ? 'Razão Social *' : 'Nome Completo *')
            },

            /**
             * Mostra que label mostrar de acordo com o person_type da empresa
             */
            labelNickname () {
                return (this.form.person_type === 'PJ' ? 'Nome Fantasia *' : 'Nome *')
            },

            /**
             * Mostra que label mostrar de acordo com o person_type da empresa
             */
            labelDocument () {
                return (this.form.person_type === 'PJ' ? 'CNPJ *' : 'CPF *')
            },

            /**
             * Verifica qual deve ser o primeiro passo caso for edição ou cadastro
             */
            finished () {
                if (this.type === 'edit') {
                    return this.activeStep === 4 || false
                }
                return this.activeStep === 5 || false
            },

            /**
             * Faz um filtro nos canais de acordo com o serviço selecionado
             */
            filteredChannels () {
                return this.options.channels.filter(item => {
                    return this.service.id_services === item.id_services
                })
            },

            /**
             * Retorna os dados da empresa gravados no state
             */
            company () {
                return this.$store.state.company
            }
        },

        // ╔═╗╦═╗╔═╗╔═╗╔╦╗╔═╗╔╦╗
        // ║  ╠╦╝║╣ ╠═╣ ║ ║╣  ║║
        // ╚═╝╩╚═╚═╝╩ ╩ ╩ ╚═╝═╩╝

        async created () {
            // Carrega os serviços e canais da empresa
            await this.loadServices()
            await this.loadChannels()

            // Se a ação for editar carregamos o formulário com os dados
            if (this.type === 'edit') {
                this.loadForm()
            }
        },

        // ╔╦╗╔═╗╔╦╗╦ ╦╔═╗╔╦╗╔═╗
        // ║║║║╣  ║ ╠═╣║ ║ ║║╚═╗
        // ╩ ╩╚═╝ ╩ ╩ ╩╚═╝═╩╝╚═╝

        methods: {

            verifyFocus () {
                this.passFocus = !this.passFocus
            },

            /**
             * Carrega os dados do cliente
             */
            async loadForm () {
                try {
                    this.$eventHub.$emit('loading', true, 'Carregando os dados do cliente.')

                    let result = await ClientsServices.find(this.$route.params.id)

                    if (result && result.status) {
                        this.form = result.results
                        this.form_services = result.results.channels
                        return
                    }

                    throw Error(result.message)
                } catch (e) {
                    this.$eventHub.$emit('snackbar', 'error', e.message || 'Não foi possível carregar os dados.')
                } finally {
                    this.$eventHub.$emit('loading', false)
                }
            },

            /**
             * Carrega os serviços da empresa
             */
            async loadServices () {
                try {
                    let result = await ServicesServices.findAll()

                    if (result && result.status) {
                        this.options.services = result.results
                        return
                    }

                    throw Error(result.message)
                } catch (e) {
                    this.$eventHub.$emit('snackbar', 'error', e.message || 'Não foi possível carregar os serviços.')
                }
            },

            /**
             * Carrega os canais da empresa
             */
            async loadChannels () {
                try {
                    let result = await ChannelsServices.findAll()

                    if (!this.company.isProvider) {
                        let resultClients = await ChannelsClientsServices.findAll()
                        result.results = result.results.filter(i => {
                            return resultClients.results.find(f => f.ch1 === i.code)
                        })
                    }

                    if (result && result.status) {
                        this.options.channels = result.results
                        return
                    }

                    throw Error(result.message)
                } catch (e) {
                    this.$eventHub.$emit('snackbar', 'error', e.message || 'Não foi possível carregar os canais.')
                }
            },

            /**
             * Salva os dados do cliente
             */
            async saveForm () {
                try {
                    this.$eventHub.$emit('loading', true, 'Salvando o cliente.')

                    this.form.svcChList = this.form_services

                    if (!this.isZiad()) {
                        this.form.custom_type = 'C'
                    }

                    let result
                    if (this.type === 'edit') {
                        result = await ClientsServices.update(this.form)
                    } else {
                        result = await ClientsServices.store(this.form)
                    }

                    if (result && result.status === 400) {
                        for (const key in result.errors) {
                            if (result.errors.hasOwnProperty(key)) {
                                const element = result.errors[key]
                                this.$eventHub.$emit('snackbar', 'error', element[0], false)
                                return
                            }
                        }
                        return
                    } else if (result && result.status) {
                        this.handleNext()
                        return
                    } else if (result.code === 406) {
                        this.$eventHub.$emit('snackbar', 'error', result.message, false)
                        return
                    } else if (result.code === 422) {
                        for (const key in result.results.errors) {
                            if (result.results.errors.hasOwnProperty(key)) {
                                const element = result.results.errors[key]
                                this.$eventHub.$emit('snackbar', 'error', element.message, false)
                                return
                            }
                        }
                        return
                    } else if (result && !result.status && !result.message) {
                        for (const key in result) {
                            if (result.hasOwnProperty(key)) {
                                const element = result[key]
                                throw Error(element[0])
                            }
                        }
                        return
                    }

                    throw Error(result.message)
                } catch (e) {
                    this.$eventHub.$emit('snackbar', 'error', e.message || 'Não foi possível salvar o cliente.')
                } finally {
                    this.$eventHub.$emit('loading', false)
                }
            },

            /**
             * Responsável por deletar o cliente
             */
            async deleteForm () {
                try {
                    this.$eventHub.$emit('loading', true, 'Aguarde, o cliente está sendo excluído.')

                    let result = await ClientsServices.destroy(this.form.id)

                    if (result && result.status) {
                        this.$eventHub.$emit('snackbar', 'success', result.message)
                        this.$router.push({ name: 'app.settings.clients' }).catch(err => { if (err) console.log(err.name || '') })
                        return
                    }

                    throw Error(result.message)
                } catch (e) {
                    this.$eventHub.$emit('snackbar', 'error', e.message || 'Não foi possível excluir o cliente.')
                } finally {
                    this.$eventHub.$emit('loading', false)
                }
            },

            /**
             * Habilita ou desabilita o dialogo para excluir o cliente
             */
            handleDialogDelete (value) {
                this.cancel.openDelete = value
            },

            /**
             * Habilita ou desabilita o dialogo para cadastrar os serviços do cliente
             */
            handleDialogService (value) {
                this.service.openService = value
            },

            /**
             * Volta uma etapa
             */
            handlePrev () {
                this.activeStep--
            },

            /**
             * Avança uma etapa com efeito scrollTo
             */
            handleNext () {
                this.activeStep++
                // let idStep = this.activeStep
                setTimeout(() => {
                    this.$scrollTo('#step-' + this.activeStep, 500, { offset: -40 })
                }, 100)
            },

            /**
             * Verifica se o tipo de assinatura for T=Test a taxa ficará em 5 reais
             */
            changeSignatureType () {
                this.form.tax = (this.form.signature_type === 'T' ? 0 : this.form.tax)
            },

            /**
             * Adiciona um serviço a lista
             */
            addService (service) {
                try {
                    // Adiciona ao array
                    this.form_services.push({
                        id_services: this.service.id_services,
                        ch1: this.service.ch1,
                        ch1_tax: this.service.ch1_tax
                    })
                    // Zera os campos atuais
                    this.service = {
                        openService: false,
                        id_services: null,
                        ch1: null,
                        ch1_tax: 0
                    }
                } catch (e) {
                    this.$eventHub.$emit('snackbar', 'error', 'Não foi possível adicionar o serviço.')
                }
            },

            /**
             * Remove um serviço pelo indice, primeiro busca o indice
             * e depois com o splice exclui
             */
            deleteService (item) {
                let index = this.form_services.indexOf(item)
                this.form_services.splice(index, 1)
            },

            /**
             * Faz uma validação dos dados informados no serviço
             */
            validateService () {
                // Busca um canal de acordo com o código dele
                const channelFunction = (channel) => {
                    return this.options.channels.find((item) => {
                        return (item.code === channel)
                    })
                }

                if (this.company.customType === 'R' && this.company.isProvider) {
                    if (!this.service.id_services) return true
                    if (!this.service.ch1) return true
                    if (this.service.ch1_tax === 'R$ 0,00' || this.service.ch1_tax === 0) return true
                    let channel = channelFunction(this.service.ch1)
                    if (this.service.ch1_tax < channel.tax_min || this.service.ch1_tax > channel.tax_max) return true
                    return false
                }
                if (!this.service.id_services) return true
                if (this.service.ch1_tax === 'R$ 0,00' || this.service.ch1_tax === 0) return true
                let channel = channelFunction(this.service.ch1)
                if (this.service.ch1_tax < channel.tax_min) return true
                return false
            },

            /**
             * Seta um canal de acordo com
             */
            setChannel () {
                if (this.company.customType === 'R' && this.company.isProvider) {
                    this.service.ch1 = ''
                    this.service.ch1_tax = 0
                } else {
                    let channels = this.filteredChannels
                    if (channels.length > 0) {
                        this.service.ch1 = channels[0].code
                    }
                }
            },

            /**
             * Busca o canal pelo CODE
             */
            getChannelName (channelId) {
                try {
                    let channel = this.options.channels.find((item) => {
                        return (item.code === channelId)
                    })
                    return channel.code || ''
                } catch (e) {
                    return ''
                }
            },

            /**
             * Trás o nome do serviço
             */
            getServiceName (typeId) {
                try {
                    let service = this.options.services.find((item) => {
                        return (item.id === typeId)
                    })
                    return service.name || ''
                } catch (e) {
                    return ''
                }
            },

            /**
             * Trás o texto do mínimo e máximo por determinado canal
             */
            getMinMaxChannel (channelId) {
                try {
                    let channel = this.options.channels.find((item) => {
                        return (item.code === channelId)
                    })
                    if (this.company.customType === 'R' && this.company.isProvider) {
                        if (channel) {
                            return `Mínimo ${this.priceFormat(channel.tax_min)} - Máximo ${this.priceFormat(channel.tax_max)}`
                        }
                    } else {
                        if (channel) {
                            return `Mínimo ${this.priceFormat(channel.tax_min)}`
                        }
                    }
                    return ''
                } catch (e) {
                    return ''
                }
            },

            /**
             * Método responsável por montar o caminho da imagem, seja ele absoluto ou em base64
             */
            getImage () {
                if (this.imageUpload) {
                    return this.form.logo_url
                }
                return `${process.env.VUE_APP_STORAGE_LOGOTIPO_PATH}/${this.form.logo_url}?nocache=${Date.now()}`
            },

            /**
             * Atualiza a imagem quando é alterado o input de imagem
             */
            async handleFileUpload (e) {
                let extensionsPossibles = ['JPG', 'JPEG', 'PNG', 'GIF']
                let files = e.target.files || e.dataTransfer.files
                let extension = files[0].name.split('.').pop()
                if (!extensionsPossibles.includes(extension.toUpperCase())) {
                    this.$eventHub.$emit('snackbar', 'error', `A extensão do arquivo não é permitido (.${extension.toUpperCase()}).`, false)
                    return
                }
                if (!files.length) return
                await this.createImage(files[0])
            },

            /**
             * Responsável por criar a imagem com o base64
             */
            async createImage (file) {
                let reader = new FileReader()
                let vm = this
                reader.onload = async (e) => {
                    vm.form.logo_url = e.target.result
                }
                reader.readAsDataURL(file)
                this.imageUpload = true
            },

            /**
             * Remove o conteúdo da propriedade logo_url para remover a imagem quando
             * os dados forem salvados
             */
            async removeImage (e) {
                this.form.logo_url = ''
            }
        }
    }
</script>

<style lang="stylus" scoped>

    @import './../../assets/stylus/bootstrap.styl'

    .info-form
        color $primary
        font-size 11px
        margin-top 5px

    .v-money
        border 1px #ccc solid
        padding 7px 10px
        border-bottom-width 2px
        width 100%

    .label-money
        padding-top 8px
        display block

    .mu-input-help
        padding-top 20px

    .form-client
        padding 30px 0

        .steps

            .step-2

                .mu-alert
                    font-size 12px
                    padding 10px 15px
                    margin-top 10px
                    i
                        color rgba(255, 255, 255, 0.6)

                .upload-image
                    width 100%
                    padding 10px 20px
                    border 1px $grey dotted
                    margin-bottom 10px
                    border-radius 5px

                    img
                        max-width 120px
                        max-height 120px

                    .button
                        text-align right

                .upload
                    width 100%
                    padding 20px
                    background lighten($grey, 70%)
                    border 1px $grey dotted
                    color darken($grey, 30%)
                    text-align center
                    position relative
                    overflow hidden
                    display inline-block
                    border-radius 5px
                    margin-bottom 20px

                    &:hover
                        background lighten($grey, 50%)

                    img
                        max-width 350px
                        margin auto

                    .title
                        margin 0
                        color darken($grey, 30%) !important

                    p
                        margin 0

                    .description
                        padding-top 20px

                        span
                            padding 0 5px

                    input[type='file']
                        border 0
                        width 100%
                        z-index 200
                        cursor pointer
                        position absolute
                        left 0
                        top 0
                        bottom 0
                        opacity 0

            .step-3
                .mu-table
                    width 100%
                    border 1px #ccc solid
                    border-radius 0 0 4px 4px
                    border-spacing 0

                    .delete
                        cursor pointer

                        &:hover
                            background $red
                            color #fff !important
                            border-radius 30px

                    .empty
                        text-align center
                        padding 50px 0
                        color #999
                        p
                            margin 0 0 15px 0

                    .text-center
                        text-align center

                    th
                        background lighten($grey, 80%)
                        height auto
                        padding 10px 5px !important

                    td
                        text-align left
                        padding 5px !important

                    tr
                        height auto
                        &:last-child
                            td
                                border 0

            .step-finished
                max-width 600px
                margin auto
                padding 50px 0
                text-align center
                font-size 14px
                color #999

            .text-center
                text-align center

            .step
                max-width 700px
                margin auto

                .line
                    width 1px
                    height 40px
                    border-left 1px #ccc solid
                    margin auto
                    display block

                .number
                    text-align center
                    margin-top 15px
                    padding 0
                    font-size 15px
                    color #999
                    background lighten($grey, 40%)
                    color #fff
                    padding 5px 10px
                    border-radius 20px
                    width 34px
                    height auto
                    margin auto
                    display block

                .title
                    text-align center
                    padding 3px 0
                    font-size 12px
                    color lighten($grey, 10%)

                .content
                    display none
                    padding 20px

                    .group-radio-button
                        padding 10px 0
                        border 1px lighten($grey, 65%) solid
                        background lighten($grey, 85%)
                        border-radius 50px
                        margin-bottom 10px

                        .mu-radio
                            margin 0 15px

                    .header
                        padding 15px
                        border-radius 4px 4px 0 0
                        color #fff

                        background $secondary
                        background -moz-linear-gradient(45deg, $secondary 0%, $primary 100%)
                        background -webkit-linear-gradient(45deg, $secondary 0%,$primary 100%)
                        background linear-gradient(45deg, $secondary 0%,$primary 100%)

                        .button
                            text-align right

                .buttons
                    padding 20px 10px
                    text-align center
                    display none
                    background lighten($grey, 85%)
                    margin-bottom 20px

                &.active

                    .title
                        color $primary
                        font-size 16px
                        padding 10px 0

                    .number
                        background $primary
                        padding 10px 20px
                        border-radius 50px
                        font-size 20px
                        width 50px
                        height auto

                    .content
                        display block

                    .buttons
                        display block

        .cancel
            background lighten(#F44336, 92%)
            padding 20px
            color #999
            border 1px #F44336 dotted
            max-width 900px
            margin auto
            margin-top 50px

            .title
                i
                    font-size 18px !important
                    color #F44336
                strong
                    font-size 16px
                    padding-left 5px
                    color #F44336

            .text-center
                text-align center

            .text-right
                text-align right

</style>
